/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'EDM',
        title: 'Enterprise Data Management',
        type: 'collapsable',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'EDM.DASHBOARD',
                title: 'Dashboard',
                type: 'basic',
                icon: 'feather:file',
                link: '/edm-dashboard',
            },
            {
                id: 'EDM.DATA-MANAGEMENT',
                title: 'Data Management',
                type: 'collapsable',
                icon: 'feather:file',
                children: [
                    {
                        id: 'EDM.DATA-MANAGEMENT.DATASET',
                        type: 'basic',
                        title: 'Datasets',
                        icon: 'feather:file',
                        link: '/data-mgmt/datasets',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.VKG-BROWSER',
                        type: 'basic',
                        title: 'VKG Data Browser',
                        icon: 'heroicons_outline:table-cells',
                        link: '/data-mgmt/vkg-browser',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.GLOSSARY',
                        type: 'collapsable',
                        title: 'Glossary',
                        icon: 'heroicons_outline:table-cells',
                        children: [
                            {
                                type: 'basic',
                                title: 'Concept Schemes',
                                icon: 'heroicons_outline:table-cells',
                                link: '/data-mgmt/glossary/conceptschemes',
                            },
                        ],
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.REFDATA',
                        type: 'collapsable',
                        title: 'Reference Data Management',
                        icon: 'heroicons_outline:table-cells',
                        children: [
                            {
                                type: 'basic',
                                title: 'Source System Translations',
                                icon: 'heroicons_outline:table-cells',
                                link: '/data-mgmt/refdata/sourcesystemtranslations',
                            },
                        ],
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.CREATE-ENTITY',
                        type: 'basic',
                        title: 'Create Entity',
                        icon: 'heroicons_outline:plus-circle',
                        link: '/data-mgmt/create-entity',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.EDIT-ENTITY',
                        type: 'basic',
                        title: 'Edit Entity',
                        icon: 'heroicons_outline:pencil-square',
                        link: '/data-mgmt/edit-entity',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.AQM',
                        type: 'collapsable',
                        title: 'Active Data Quality',
                        icon: 'heroicons_outline:adjustments-vertical',
                        children: [
                            {
                                type: 'basic',
                                title: 'Linked Data Quality',
                                icon: 'heroicons_outline:arrow-trending-up',
                                link: '/data-mgmt/dqm/ldq',
                            },
                            {
                                type: 'basic',
                                title: 'Distributed Data Quality',
                                icon: 'heroicons_outline:arrow-trending-up',
                                link: '/data-mgmt/dqm/ddq',
                            },
                            {
                                type: 'basic',
                                title: 'DQ Task List',
                                icon: 'heroicons_outline:arrow-trending-up',
                                link: '/data-mgmt/dqm/dqtasklist',
                            },
                            {
                                type: 'basic',
                                title: 'Manage Rulesets',
                                icon: 'heroicons_outline:arrow-trending-up',
                                link: '/data-mgmt/dqm/manage-rulesets',
                            }
                        ],
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.MARKETPLACE',
                        type: 'basic',
                        title: 'Data Marketplace',
                        icon: 'heroicons_outline:shopping-bag',
                        link: '/data-mgmt/marketplace',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.ES-CONNECTORS',
                        type: 'basic',
                        title: 'Elasticsearch Connectors',
                        icon: 'heroicons_outline:magnifying-glass',
                        link: '/data-mgmt/es-connectors',
                    },
                    {
                        id: 'EDM.DATA-MANAGEMENT.DATA-ENTITY-SEARCH',
                        title: 'Data Entity Search',
                        icon: 'feather:search',
                        type: 'basic',
                        link: '/ekc/entitysearch',
                    },
                ],
            },
            {
                id: 'EDM.EKC',
                title: 'Enterprise Knowledge Catalog',
                type: 'collapsable',
                icon: 'feather:file-plus',
                children: [
                    {
                        id: 'EDM.EKC.DATA-ASSETS',
                        type: 'collapsable',
                        title: 'Data Assets',
                        icon: 'feather:file-plus',
                        children: [
                            {
                                id: 'EDM.EKC.DATA-ASSETS.ONTOLOGY-DOMAINS',
                                title: 'Ontology Domains',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataassets/ontologydomains',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.DATA-ELEMENTS',
                                title: 'Data Elements',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataelements',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.DATA-ENTITIES',
                                title: 'Data Entities',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataentities',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.DATA-SHAPES',
                                title: 'Data Shapes',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataassets/datashapes',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.DATA-DATAMODELS',
                                title: 'Data Models',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataassets/datamodels',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.EXTERNAL-ONTOLOGY',
                                title: 'External Ontology Import',
                                icon: 'feather:upload',
                                type: 'basic',
                                link: '/ekc/dataassets/externalontology',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.VKG',
                                title: 'VKG Repo Management',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataassets/vkg',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.BUSINESS-TERMS',
                                title: 'Business Terms',
                                icon: 'feather:file',
                                type: 'basic',
                                link: '/ekc/dataassets/businessterms',
                            },
                            {
                                id: 'EDM.EKC.DATA-ASSETS.RELATIONSHIP-DIAGRAMS',
                                title: 'Relationship Diagrams',
                                icon: 'feather:git-merge',
                                type: 'basic',
                                link: '/ekc/dataassets/relationshipdiagrams',
                            },
                        ],
                    },
                ],
            },
            {
                id: 'EDM.CODP',
                title: 'Connected Data Platforms',
                type: 'collapsable',
                icon: 'feather:file',
                children: [
                    {
                        id: 'EDM.CODP.DATA-CONNECTORS',
                        title: 'Data Connectors',
                        type: 'basic',
                        link: '/edm/cdp/data-connectors',
                    },
                ],
            },
            {
                id: 'EDM.HARVESTER',
                title: 'Harvester',
                type: 'collapsable',
                icon: 'feather:download',
                children: [
                    {
                        id: 'EDM.HARVESTER.METADATA-EXTRACTION-REQUEST',
                        title: 'Metadata Extraction Request',
                        type: 'basic',
                        link: '/edm/harvester/metadata-extraction-request',
                    },
                ],
            },
            // {
            //     id: 'EDM.EDMP',
            //     title: 'Enterprise Data Market place',
            //     type: 'basic',
            //     link: '/edm/edmp',
            // },
        ],
    },
    {
        id: 'EDM.APPS',
        title: 'SDF Applications',
        type: 'collapsable',
        icon: 'heroicons_outline:qr-code',
        // SDF2026-309: per-app sidebar entries previously fetched live from sdf-kg-ekc-service and
        // prepended here at runtime by NavigationService._mergeSdaApplicationNavigation (now
        // removed) were replaced by a single static 'Linked Apps' catalog entry below, fetched from
        // GET /ekc/v1/sdf/metadata/applications. An internal SDA app that has a real route inside
        // Knightfly itself (like Linked MDM) gets its own static entry here instead -- ekc-service's
        // getLinkedApps excludes any tdm:Application resolving to an internal Knightfly route, so
        // the catalog only ever lists genuinely external (or not-yet-hosted) apps.
        children: [
            {
                id: 'EDM.APPS.LINKEDAPPS',
                title: 'Linked Apps',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/linked-apps',
            },
            {
                id: 'EDM.APPS.LMDM',
                title: 'Linked MDM',
                type: 'basic',
                icon: 'heroicons_outline:circle-stack',
                link: '/linkedmdm',
            },
            {
                id: 'EDM.APPS.EVENTS',
                type: 'basic',
                title: 'Events',
                icon: 'heroicons_outline:bolt',
                link: '/events',
            },
            {
                id: 'EDM.APPS.DU',
                title: 'Data Unification',
                type: 'collapsable',
                icon: 'heroicons_outline:table-cells',
                children: [
                    {
                        id: 'EDM.APPS.DU.DuSummary',
                        type: 'basic',
                        title: 'DU Summary',
                        link: '/du',
                    },
                    {
                        id: 'EDM.APPS.DU.SS',
                        type: 'basic',
                        title: 'Source Systems',
                        link: '/du/sourceSystems',
                    },
                    {
                        id: 'EDM.APPS.DU.DP',
                        type: 'basic',
                        title: 'Data Providers',
                        link: '/du/dataProviders',
                    },
                    {
                        id: 'EDM.APPS.DU.SDI',
                        type: 'basic',
                        title: 'Supplier Data Interface',
                        link: '/du/sdi',
                    },
                    {
                        id: 'EDM.APPS.DU.STM',
                        type: 'basic',
                        title: 'Source to LD Mappings',
                        link: '/du/stm',
                    },
                    {
                        id: 'EDM.APPS.DU.BFO',
                        type: 'basic',
                        title: 'Bulk File Onboarding',
                        link: '/du/bulkFileOnboarding',
                    },
                    {
                        id: 'EDM.APPS.DU.BFO.Sessions',
                        type: 'basic',
                        title: 'Onboarding Sessions',
                        link: '/du/bulkFileOnboarding/sessions',
                    },
                    {
                        id: 'EDM.APPS.DP.ER',
                        type: 'collapsable',
                        title: 'Entity Resolution',
                        icon: 'heroicons_outline:arrow-path-rounded-square',
                        children: [
                            {
                                id: 'EDM.APPS.DP.ER.MP',
                                type: 'basic',
                                title: 'Matching Profile Configuration',
                                link: '/ero/matchingprofile',
                            },
                            {
                                // SDF2026-305 added a new Entity Search page under /ekc, with its
                                // own service and model. This menu item was never repointed, so it
                                // kept opening the legacy /ero component (last touched 2026-05-11)
                                // and appeared not to launch. One screen, so the menu points at the
                                // current one rather than a second route being added.
                                id: 'EDM.APPS.DP.ER.ES',
                                type: 'basic',
                                title: 'Entity Search',
                                link: '/ekc/entitysearch',
                            },
                            {
                                id: 'EDM.APPS.DP.ER.wnyentity',
                                type: 'basic',
                                title: 'Why Entities',
                                link: '/ero/whyentity',
                            },
                            {
                                id: 'EDM.APPS.DP.ER.MatchReview',
                                type: 'basic',
                                title: 'Match Review Queue',
                                link: '/ero/matchreview',
                            },
                            {
                                id: 'EDM.APPS.DP.ER.MatchExplorer',
                                type: 'basic',
                                title: 'Match Outcome Explorer',
                                link: '/ero/matchexplorer',
                            },
                            {
                                id: 'EDM.APPS.DP.ER.SyncIssues',
                                type: 'basic',
                                title: 'Sync Issues',
                                link: '/ero/syncissues',
                            },
                        ],
                    },
                ],
            },
            {
                id: 'EDM.APPS.DATAOPS',
                title: 'Data Ops',
                type: 'collapsable',
                icon: 'heroicons_outline:cog-6-tooth',
                children: [
                    {
                        id: 'EDM.APPS.DATAOPS.Processes',
                        type: 'basic',
                        title: 'Processes',
                        link: '/du/processes',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.WorkflowTracking',
                        type: 'basic',
                        title: 'Workflow Tracking',
                        link: '/du/workflowTracking',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.ProcessingErrors',
                        type: 'basic',
                        title: 'Processing Errors',
                        link: '/du/processingErrors',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.RecurringIssues',
                        type: 'basic',
                        title: 'Recurring Issues',
                        link: '/du/recurringIssues',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.FeedSla',
                        type: 'basic',
                        title: 'Feed SLA',
                        link: '/du/feedSla',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.SlaOlaTracker',
                        type: 'basic',
                        title: 'SLA / OLA Tracker',
                        link: '/du/slaOlaTracker',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.MailTemplates',
                        type: 'basic',
                        title: 'Mail Templates',
                        link: '/ekc/mailtemplates',
                    },
                    {
                        id: 'EDM.APPS.DATAOPS.RuleCatalog',
                        type: 'basic',
                        title: 'Rule Catalog',
                        link: '/ekc/rulecatalog',
                    },
                ],
            },
        ],
    },
    {
        id: 'ADMIN',
        title: 'Admin',
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: 'ADMIN.USER-MANAGEMENT',
                type: 'basic',
                title: 'User Management',
                icon: 'heroicons_outline:users',
                link: '/admin/userManagement',
            },
            {
                id: 'ADMIN.ROLE-MANAGEMENT',
                type: 'basic',
                title: 'Role Management',
                icon: 'heroicons_outline:key',
                link: '/admin/roleManagement',
            },
            {
                id: 'ADMIN.MODEL-DEPLOYMENTS',
                type: 'basic',
                title: 'Model Deployments',
                icon: 'heroicons_outline:cloud-arrow-up',
                link: '/admin/modelDeployments',
            },
        ],
    },
    {
        id: 'ONTOASK',
        title: 'OntoAsk',
        type: 'basic',
        icon: 'heroicons_outline:sparkles',
        link: '/ontoask',
    },
    {
        id: 'DATA_GOVERNANCE',
        title: 'Data Governance',
        type: 'collapsable',
        icon: 'heroicons_outline:shield-check',
        children: [
            {
                id: 'DATA_GOVERNANCE.PROPERTY_MANAGEMENT',
                title: 'Data Property Management',
                type: 'basic',
                icon: 'heroicons_outline:table-cells',
                link: '/data-governance',
            },
            {
                id: 'DATA_GOVERNANCE.REVIEW_QUEUE',
                title: 'Review Queue',
                type: 'basic',
                icon: 'heroicons_outline:clock',
                link: '/data-mgmt/review-queue',
            },
            {
                id: 'DATA_GOVERNANCE.BATCH_UPDATE_REVIEW',
                title: 'Batch Update Review',
                type: 'basic',
                icon: 'heroicons_outline:arrows-right-left',
                link: '/data-mgmt/batch-update-review',
            },
            {
                // SDF2026-495. A task list of its own, NOT a row on the dashboard's Needs Attention
                // panel: that panel is for work with no workflow task behind it, and every review
                // here has a live Camunda user task.
                id: 'DATA_GOVERNANCE.OVERRIDE_REVIEWS',
                title: 'Override Reviews',
                type: 'basic',
                icon: 'heroicons_outline:hand-raised',
                link: '/data-mgmt/override-reviews',
            },
        ],
    },
    // {
    //     id: 'GLIDE',
    //     title: 'Glide (Legacy)',
    //     type: "collapsable",
    //     icon: 'heroicons_outline:home',
    //     children: [
    //         {
    //             id: 'GLIDE.DATA-ASSETS',
    //             title: 'Data Assets',
    //             type: "collapsable",
    //             children: [
    //                 {
    //                     id: 'GLIDE.DATA-ASSETS.DATA-ELEMENTS',
    //                     title: 'Data Elements',
    //                     type: "basic",
    //                     link: '/glide/data-assets/data-elements'
    //                 }
    //             ]
    //         }
    //     ]
    // }
];
// Rendered in the vertical navigation's fixed footer slot, separate from the
// functional/app navigation tree above.
export const helpNavigation: FuseNavigationItem[] = [
    {
        id: 'EDM.DOC',
        title: 'Everything you need to know about KF/EDM',
        type: 'collapsable',
        icon: 'mat_solid:contact_support',
        children: [
            {
                id: 'documentation.changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:speakerphone',
                link: '/edm/docs/changelog',
                badge: {
                    title: '1.0.10',
                    classes: 'px-2 bg-yellow-300 text-black rounded-full',
                },
            },
            {
                id: 'documentation.guides',
                title: 'Guides',
                type: 'basic',
                icon: 'heroicons_outline:book-open',
                link: '/edm/docs/guides',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
